export interface LeadDialogTitleSource {
	formName?: string;
	description?: string;
	rawExtraData?: string;
}

const requestTypeFields = ['Тип заявки', 'Тип+заявки', 'Тип_заявки'];
const specificationFields = ['Специфика_2', 'Направление'];
const specificationFieldLabels: { [field: string]: string } = {
	'Специфика_2': 'Специфика',
	'Направление': 'Направление',
};
export function getLeadDialogTitle(lead: LeadDialogTitleSource, fallback = 'Лид (тикет)'): string {
	const parts: string[] = [];

	const formName = (lead.formName || '').trim();
	if (formName) {
		parts.push(formName);
	}

	const extra = parseRawExtraData(lead.rawExtraData);

	const requestType = getFirstMatchedExtraValue(extra, requestTypeFields);
	if (requestType) {
		parts.push(`Тип заявки: ${requestType.value}`);
	}

	const specification = getFirstMatchedExtraValue(extra, specificationFields);
	if (specification) {
		const label = specificationFieldLabels[specification.field] || specification.field;
		parts.push(`${label}: ${specification.value}`);
	}
	if (parts.length > 0) {
		return parts.join('. ');
	}

	const description = (lead.description || '').trim();
	return description || fallback;
}

export function applyLeadDialogTitle(
	dialogRef: { dialog?: { instance?: { title?: string }; location?: { nativeElement?: HTMLElement } } } | null,
	lead: LeadDialogTitleSource
): void {
	if (!dialogRef || !dialogRef.dialog) {
		return;
	}

	const nativeElement = dialogRef.dialog.location && dialogRef.dialog.location.nativeElement;
	if (nativeElement && nativeElement.classList) {
		nativeElement.classList.add('lead-detail-kendo-dialog');
	}

	if (dialogRef.dialog.instance) {
		dialogRef.dialog.instance.title = getLeadDialogTitle(lead);
	}
}

function parseRawExtraData(rawExtraData?: string): Record<string, string> {
	if (!rawExtraData) {
		return {};
	}

	try {
		const parsed = JSON.parse(rawExtraData) as Record<string, string>;
		return parsed || {};
	} catch (_error) {
		return {};
	}
}

function getFirstMatchedExtraValue(extra: Record<string, string>, keys: string[]): { field: string; value: string } | null {
	for (let i = 0; i < keys.length; i++) {
		const key = keys[i];
		const normalizedKey = normalizeFieldKey(key);
		for (const extraKey in extra) {
			if (!extra.hasOwnProperty(extraKey)) {
				continue;
			}

			if (normalizeFieldKey(extraKey) === normalizedKey) {
				const value = (extra[extraKey] || '').trim();
				if (value) {
					return { field: key, value: value };
				}
			}
		}
	}

	return null;
}

function normalizeFieldKey(key: string): string {
	return (key || '')
		.replace(/\+/g, ' ')
		.replace(/\u00a0/g, ' ')
		.replace(/\s+/g, ' ')
		.trim()
		.toLowerCase();
}